import { createContext, useContext } from 'react';

import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PublicRuntimeConfig = { [key: string]: any };

const PublicRuntimeConfigContext = createContext<PublicRuntimeConfig>({});

export const PublicRuntimeConfigProvider: ReactFCWithChildren<{
  publicRuntimeConfig: PublicRuntimeConfig;
}> = ({ children, publicRuntimeConfig }) => {
  return (
    <PublicRuntimeConfigContext.Provider value={publicRuntimeConfig}>
      {children}
    </PublicRuntimeConfigContext.Provider>
  );
};

export const usePublicRuntimeConfig = (): PublicRuntimeConfig => {
  const publicRuntimeConfig = useContext(PublicRuntimeConfigContext);

  if (!publicRuntimeConfig) {
    throw new Error('usePublicRuntimeConfig must be used within a PublicRuntimeConfigProvider');
  }

  return publicRuntimeConfig;
};
